import React from 'react';

export const EmptyPollsState: React.FC = () => {
  return (
    <div
      style={{
        textAlign: 'center',
        padding: '64px 24px',
        backgroundColor: '#f9fafb',
        borderRadius: '12px',
        border: '1px dashed #d1d5db',
      }}
    >
      <i
        className="pi pi-check-circle"
        style={{
          fontSize: '4rem',
          color: '#10b981',
          marginBottom: '16px',
          display: 'block',
        }}
      />
      <h3
        style={{
          color: '#1f2937',
          fontSize: '20px',
          fontWeight: 600,
          margin: '0 0 8px 0',
        }}
      >
        כל הכבוד!
      </h3>
      <p
        style={{
          color: '#6b7280',
          fontSize: '16px',
          margin: 0,
        }}
      >
        אין משובים ממתינים למילוי כרגע.
        <br />
        מילאת את כל המשובים הנדרשים.
      </p>
    </div>
  );
};
